module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C277"
  }, [_c('a', {
    attrs: {
      "id": "page_XVII"
    }
  }, [_vm._v("DRAMATIS PERSONAE")])]), _c('a', {
    attrs: {
      "id": "page_XVII"
    }
  }, [_c('p', {
    staticClass: "C293"
  }, [_c('strong', [_vm._v("FAMILY")])]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("James Bradford Pier (Uncle Pier)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Lu Merry Pier (Aunt Lu)")]), _vm._v(" "), _c('p', {
    staticClass: "C906"
  }, [_c('em', [_vm._v("Lucy’s mother’s sister")])]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("CHILDREN")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Sarah Pier (Cousin Sarah)")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Sammy Pier (Cousin Sammy)")]), _vm._v(" "), _c('p', {
    staticClass: "C906"
  }, [_vm._v("Lu Pier Cochran (Cousin Lu)")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("SLAVES")]), _vm._v(" "), _c('p', {
    staticClass: "C906"
  }, [_vm._v("Dick, Parrot, Winnie, Ellen")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Waller Cochran (Cousin Waller)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Lu Cochran (Cousin Lu)")]), _vm._v(" "), _c('p', {
    staticClass: "C906"
  }, [_c('em', [_vm._v("Daughter of J. B. & Lu Pier")])]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("SON")]), _vm._v(" "), _c('p', {
    staticClass: "C906"
  }, [_vm._v("Willie Cochran")]), _vm._v(" "), _c('p', {
    staticClass: "C296"
  }, [_vm._v("SLAVES")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Catharine, Lucinda, Sally, Ike,")]), _vm._v(" "), _c('p', {
    staticClass: "C906"
  }, [_vm._v("George, Rose, Beckie, Willis")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Uncle Martin Merry")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Aunt Hannah Merry")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_c('em', [_vm._v("Aunt Lu’s brother; Lucy’s")])]), _vm._v(" "), _c('p', {
    staticClass: "C906"
  }, [_c('em', [_vm._v("mother’s brother")])]), _vm._v(" "), _c('p', {
    staticClass: "C293"
  }, [_c('strong', [_vm._v("FRIENDS")])]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. Bell & Elizabeth Bell")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Callie, Sack, Newt, Jane,")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Shiloah, Sallie Lu")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("George Bell")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Brewer")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Lissie, Mollie, Elizabeth,")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Sallie Pier")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Buck")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Bella")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Cameron")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Artie, Willie")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Cyrus Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Austin")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Rufus Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Sarah")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Catlin")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Sallie Lou, Todie, Sukie")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Chapman")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Charley")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Clemmons")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Sallie, Jimmy")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Cleveland")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Annie, Caroline")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Cochran")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Nehemiah (Neh), Emma,")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Jimmie, Mollie, Tallie")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("“Uncle” Jimmy Cochran")])]), _c('p', {
    staticClass: "C904"
  }, [_c('a', {
    attrs: {
      "id": "page_XVII"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XVIII"
    }
  }, [_vm._v("Mr. & Mrs. Darnman Lulu")])]), _c('a', {
    attrs: {
      "id": "page_XVIII"
    }
  }, [_c('p', {
    staticClass: "C904"
  }, [_vm._v("Lydia Francis")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Anson Harvey")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Lissie Jackson")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Sallie Kavanaugh")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Kate Kenney, Sue Kenney")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Dentist Lee")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. LottEmily")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Dr. & Mrs. McLarin Sallie, Bolie, Sue, Fannie")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mollie McNeese")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Middleton")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Annie Roach")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Bracey Roach")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. S")]), _vm._v(" "), _c('p', {
    staticClass: "C908"
  }, [_vm._v("Joe, Ruf, & Ino Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Grandma Swearingen")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Sallie Swearingen")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Sallie T.")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Sis Torrence")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Tom")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Sue Wilson")]), _vm._v(" "), _c('p', {
    staticClass: "C293"
  }, [_c('strong', [_vm._v("SOLDIER BOYS")])]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("George Bell")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Joe Blakley")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Harry Bracey")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Benton Brewer")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Rufus Brewer")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Jim Brewer")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("William Brewer")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Trav C")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Cy Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Joe Campbell (died)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Ino Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mack Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Jake Catlin")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. Chesley (former teacher/Travis)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Jimmy Clemmons")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Nehemiah (Neh) Cochran")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Jack Cochran (died)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Hez Collins")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Kinch Collins")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Ino E")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Billy Fordtran")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Stickney Fowler (died)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Jimmy Francis (died)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("John Harvey")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Ino Harvey")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Captain Hunt")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Martin Kenny")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Nick Merry (deserted)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Robert Minton")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Sammy Pier")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Charlie Uckert")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Henry P. Wiley")])]), _c('p', {
    staticClass: "C293"
  }, [_c('a', {
    attrs: {
      "id": "page_XVIII"
    }
  }, [_c('strong')]), _c('strong', [_c('a', {
    attrs: {
      "id": "page_XIX"
    }
  }, [_vm._v("ACQUAINTANCES")])])]), _c('a', {
    attrs: {
      "id": "page_XIX"
    }
  }, [_c('p', {
    staticClass: "C904"
  }, [_vm._v("Marion Adams")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Captain S. Adkins (aboard the "), _c('em', [_vm._v("Fox")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("“Aunt” Violet & “Uncle” Frank (lost home in fire)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Lieut. Baldwin (visiting Havana)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. Baldwin & Bessie (friends of Uncle Martin)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Harry Bracey")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Bush (residents of Hempstead)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. George Chambers (friend of Mrs. Peebles)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Clark (friend of Mrs. Peebles)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Dr. & Mrs. Cocke, Willie")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Louise (a slave)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Day, Fanny")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. Dunn")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Fadi (resident of Hempstead)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. Ferris (resident of Galveston)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Billy Francis (lived near Cousin Lu)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. Groves (resident of Hempstead)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. Joseph Hendley (Galveston)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. William Hendley (Galveston)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Parson Kenney")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. Linn")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Mason (residents of Galveston)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Miss McHenry")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Jim Middleton")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Jennie Minton")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. Murdock (aboard the "), _c('em', [_vm._v("Fox")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Paine")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Dr. & Mrs. Peebles")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Maggie, Rachel, Samie")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. & Mrs. Pilley")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Purcell, Sue")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Dr. & Mrs. Richie")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Scranton (resident of Galveston)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mr. John Sleight (Galveston)")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Miss Mary Smith")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Bell Snood")]), _vm._v(" "), _c('p', {
    staticClass: "C904"
  }, [_vm._v("Mrs. Stevens, Ella")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2907e408","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Dramatis_Personae.vue
// module id = 81
// module chunks = 0